/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Failedunsubscribe1Inputs */

const id_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal berhenti berlangganan notifikasi`)
};

const ms_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal berhenti melanggan pemberitahuan`)
};

const da_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke afmelde notifikationer`)
};

const de_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmeldung von Benachrichtigungen fehlgeschlagen`)
};

const en_us2_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to unsubscribe from notifications`)
};

const es_es2_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al desuscribirse de las notificaciones`)
};

const es_mx2_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cancelar la suscripción a las notificaciones`)
};

const fil_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigong mag-unsubscribe mula sa mga notipikasyon`)
};

const fr_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du désabonnement des notifications`)
};

const it_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile annullare l'iscrizione alle notifiche`)
};

const hu_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikertelen leiratkozás az értesítésekről`)
};

const nl_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitschrijven van meldingen mislukt`)
};

const no_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke melde seg av varsler`)
};

const pl_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wypisać z powiadomień`)
};

const pt_br2_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to unsubscribe from notifications`)
};

const pt_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao cancelar subscrição de notificações`)
};

const ro_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezabonarea de la notificări a eșuat`)
};

const fi_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitusten tilauksen peruutus epäonnistui`)
};

const sv_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misslyckades att avsluta notisprenumeration`)
};

const vi_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy đăng ký thông báo thất bại`)
};

const tr_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirim aboneliği iptal edilemedi`)
};

const cs_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepodařilo se odhlásit od oznámení`)
};

const bg_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешно отписване от известия`)
};

const ru_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось отписаться от уведомлений`)
};

const uk_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося відписатися від сповіщень`)
};

const ar_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل إلغاء الاشتراك من الإشعارات`)
};

const hi_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाओं से सब्सक्रिप्शन रद्द करने में विफल`)
};

const th_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิกการสมัครรับการแจ้งเตือนไม่สำเร็จ`)
};

const ja_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知の購読解除に失敗しました`)
};

const zh_cn2_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to unsubscribe from notifications`)
};

const zh_hant1_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to unsubscribe from notifications`)
};

const ko_notifications_simple_failedunsubscribe1 = /** @type {(inputs: Notifications_Simple_Failedunsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to unsubscribe from notifications`)
};

/**
* | output |
* | --- |
* | "Failed to unsubscribe from notifications" |
*
* @param {Notifications_Simple_Failedunsubscribe1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_failedunsubscribe1 = /** @type {((inputs?: Notifications_Simple_Failedunsubscribe1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Failedunsubscribe1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "ms") return ms_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "da") return da_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "de") return de_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "fil") return fil_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "fr") return fr_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "it") return it_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "hu") return hu_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "nl") return nl_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "no") return no_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "pl") return pl_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "pt") return pt_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "ro") return ro_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "fi") return fi_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "sv") return sv_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "vi") return vi_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "tr") return tr_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "cs") return cs_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "bg") return bg_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "ru") return ru_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "uk") return uk_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "ar") return ar_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "hi") return hi_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "th") return th_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "ja") return ja_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_failedunsubscribe1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_failedunsubscribe1(inputs)
	return ko_notifications_simple_failedunsubscribe1(inputs)
});
export { notifications_simple_failedunsubscribe1 as "notifications.simple.failedUnsubscribe" }